export const truncate = (input, numCharacters) => {
    return input.length > numCharacters ? `${input.substring(0, numCharacters)}...` : input;
}
